export const PACKAGE_NAME = 'jiraBusinessList';
export const SUBTASK_HIERARCHY_LEVEL = -1;
